





















import Vue from 'vue'
import { LabelWithButtonElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'labelWithButton',
  props: {
    templateItemData: {
      type: Object as () => LabelWithButtonElInterface,
      required: true
    }
  }
})
